module.exports = "<current-warning-list terms=\"vm.terms\"></current-warning-list>"